import { CLOUD_PROVIDERS } from '@couch/shared';
import { CloudCostWarning, ConsoleLink } from '../machines/CloudBadge';
import { GcpKeyPanel } from './GcpKeyPanel';

const CONSOLE = 'https://console.cloud.google.com';

/** Google Cloud: what to set up once, and where the key lives (doc 67). */
export function GcpSection() {
  return (
    <section className="panel" aria-labelledby="gcp-title">
      <h2 id="gcp-title">Google Cloud — GPU machines Couch creates for you</h2>
      <p>Couch creates a VM with an NVIDIA L4 in Europe, installs itself on it, starts and stops it. Set this up once:</p>
      <CloudCostWarning />
      <ConsoleLink href={CLOUD_PROVIDERS.gcp.console} provider="gcp" />
      <ol className="connection-steps">
        <li>
          In the <a href={CONSOLE} target="_blank" rel="noopener noreferrer">Google Cloud console ↗</a>, create a <strong>project</strong> —
          best without an organisation: new organisations block the key you need in step 5.
        </li>
        <li>Link a <strong>billing account</strong>. The free trial has no GPUs; after the upgrade the trial credit is still yours.</li>
        <li>Switch on the <strong>Compute Engine API</strong>.</li>
        <li>
          Under IAM &amp; Admin → <strong>Quotas</strong>, ask for <em>GPUs (all regions)</em> = 1 and <em>Preemptible NVIDIA L4 GPUs</em> = 1 in a
          European region, e.g. europe-west4. Google may take from minutes to two days.
        </li>
        <li>
          Under IAM &amp; Admin → <strong>Service accounts</strong>, create one (e.g. couch-vm-admin) with only the role
          <strong> Compute Instance Admin (v1)</strong>, then Keys → Add key → <strong>JSON</strong>. Keep the file to yourself — never paste it into a chat.
        </li>
      </ol>
      <GcpKeyPanel />
    </section>
  );
}
